import { render, staticRenderFns } from "./HairTypesRegistryNewForm.vue?vue&type=template&id=e92c7280"
import script from "./HairTypesRegistryNewForm.vue?vue&type=script&lang=js"
export * from "./HairTypesRegistryNewForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports